import { Filter } from 'CommonData/poco/index';

export class FilterMapper {
    public static map(data: any): Array<Filter> {
        if (!data) {
            throw 'No data for mapper: FilterMapper';
        }

        let filters: Array<Filter> = [];

        const unmappedFilters = data.filters;
        if (!unmappedFilters) {
            return filters;
        }

        const filterKeys = [...new Set(unmappedFilters.map((f: any) => f.key))];

        filterKeys.forEach((fk: string) => {
            filters.push(new Filter({
                key: fk,
                values: []
            }));
        });

        unmappedFilters.forEach((uf: any) => {
            let matchingFilter = filters.find((f: Filter) => f.key === uf.key);
            matchingFilter.values.push({
                value: uf.value,
                metaKey: uf.metaType,
                metaValue: uf.meta
            });
        });

        return filters;
    }
} 